import { Component, ElementRef } from '@angular/core';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { MicroStateService } from 'src/app/services/micro-state.service';

import anime from 'animejs/lib/anime.es';
import { UserListsService } from 'src/app/services/user-lists.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SubMonitorService } from 'src/app/services/sub-monitor.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-saved-songs',
  templateUrl: './saved-songs.component.html',
  styleUrl: './saved-songs.component.scss'
})
export class SavedSongsComponent {
  user: any;
  userLists: any;
  isLoading: boolean = true;
  searchQuery: string = '';
  private searchQuerySubject = new Subject<string>();
  searchActive: boolean = false;

  constructor(
    private microState: MicroStateService,
    private el: ElementRef,
    private listService: UserListsService,
    private router: Router,
    private subMonitor: SubMonitorService,
    private titleService: Title,
  ) {
    this.titleService.setTitle('Song Identity - My Lists');
    this.searchQuerySubject.pipe(debounceTime(200)).subscribe(() => {
      this.onInputChange();
    });
  }

  ngOnInit() {
    this.loadUserData();

    this.subMonitor.getSubscription().subscribe((data) => {
      if (data === 'expired') { 
        this.router.navigate(['activate-subscription'])
       };
    });
  };

  async loadUserData() {
    const auth = await this.getAuthState();
    if (auth.currentUser) {
      this.user = auth.currentUser;
      this.getUserLists();
    }
  };

  async getAuthState() {
    return getAuth();
  };

  getUserLists() {
    this.listService.getListsByUserId(this.user.uid).then((data) => {
      if (data) {
        this.isLoading = false;
        this.userLists = data.sort((a ,b) => b.updatedAt - a.updatedAt);
        if (data.length === 0) {
          this.handleAnimateEmptyState();
        } else {
          this.handleAnimateLists();
        }
      } else {
        this.isLoading = false;
        console.log('Error getting user lists'); // TODO: Add friendly error
      }
    })
  }

  onClickList(list) {
    this.router.navigate(['list',list.id])
  }
 

  // UTILITIES 

  getTileClass(numberOfTiles: number): string {
    switch (numberOfTiles) {
      case 1:
        return 'single-tile';
      case 2:
      case 3:
      case 4:
        return 'quad-tile';
      default:
        return '';
    }
  }

  onInputChange() {
    if (this.searchQuery.length > 0) {
      this.searchActive = true;
    }
  }

  triggerSearchQuery() {
    this.searchQuerySubject.next(this.searchQuery);
  }

  handleClearSearch() {
    this.searchQuery = '';
  }

  // ANIMATIONS

  handleAnimateEmptyState() {
    const emptyStateAnimation = anime.timeline({ autoplay: false, loop: false });

    setTimeout(() => {
      // const emptyState = this.el.nativeElement.querySelector('#empty-state');

      emptyStateAnimation
        .add({
          targets: '.lists-empty-state',
          scale: [1.05, 1],
          opacity: [0, 1],
          translateY: [-40, 0],
          easing: 'easeOutCubic',
          duration: 900,
        })
        .add({
          targets: '.lists-empty-state svg',
          scale: [1.05, 1],
          opacity: [0, 1],
          translateY: [-5, 0],
          duration: 600,
        }, 200)
        .add({
          targets: '.lists-empty-state .message',
          scale: [1.05, 1],
          opacity: [0, 1],
          translateY: [12, 0],
          easing: 'easeOutCubic',
          duration: 600,
        }, 400);
      emptyStateAnimation.play();
    }, 100);
  }

  handleAnimateLists() {
    const listAnimation = anime.timeline({ autoplay: false, loop: false });

    setTimeout(() => {
      listAnimation
        .add({
          targets: '.header',
          opacity: [0, 1],
          translateY: [4, 0],
          easing: 'cubicBezier(.74, .11, .5, 1.26)',
          duration: 700,
        })
        .add({
          targets: '.list-search-wrapper',
          opacity: [0, 1],
          translateY: [4, 0],
          easing: 'cubicBezier(.74, .11, .5, 1.26)',
          duration: 600,
        }, 100)
        .add({
          targets: '.list-item',
          opacity: [0, 1],
          translateY: [4, 0],
          easing: 'easeOutExpo',
          duration: 600,
          delay: anime.stagger(100), // Stagger the animations by 100 milliseconds
        }, 400)
      listAnimation.play();
    }, 100);
  }

}
